import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { useHeaderTabs } from '@e3dc-react/shell/Libs/Header'
import { appUpdate } from '@e3dc-react/shell/State/App/AppActions'
import { Grid } from '@mui/material'
import React, { useContext, useEffect } from 'react'
import { useDispatch } from 'react-redux'
import SystemSettingCard from 'src/Elements/SystemSettings/SystemSettingCard'
import { BannerLocations, BannerQueue } from 'src/Libs/banners'
import { InstallationOnlineStatusContext } from 'src/Libs/installations/context/installation-online-status-context'
import { useTypedSelector } from 'src/State/RootReducer'
import useE3dcSystemSettingsOverviewCardConfigs from '../hooks/use-e3dc-system-settings-overview-card-configs'

/**
 * This component provides a menu where each item is displayed as a card.
 * Items represent system settings in different areas of an installation (e.g. solar, battery, ...)
 */
const E3dcSystemSettingOverview: React.FC = () => {
  const dispatch = useDispatch()
  const { t } = useCustomTranslation()
  const { setTabs } = useHeaderTabs()
  const activeInstallation = useTypedSelector(state => state.storage.activeInstallation)
  const activeStorage = useTypedSelector(state => state.storage.activeStorage)
  const systemSettingsOverviewCardConfigs = useE3dcSystemSettingsOverviewCardConfigs()

  useEffect(() => {
    dispatch(appUpdate({ title: t('framework.systemProperties') }))
    setTabs([])
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const settingsPagePath = `/installation/${activeInstallation}/${activeStorage}/properties`
  const { isStorageOnline } = useContext(InstallationOnlineStatusContext)

  return (
    <Grid container>
      <BannerQueue location={BannerLocations.SettingsOverview} sx={{ mt: 2, mb: 0, ml: 2 }} />
      <Grid item xs={12}>
        <Grid container spacing={2}>
          {systemSettingsOverviewCardConfigs.map((data, index) => (
            <Grid item xs={6} md={4} key={`setting-card-${data.title}`}>
              <SystemSettingCard
                title={data.title}
                description={data.description}
                icon={data.icon}
                data-qa={`system-setting-${index}`}
                path={isStorageOnline ? data.path : settingsPagePath}
                hasNewContent={data.hasNewContent}
                elementKey={data.elementKey}
              />
            </Grid>
          ))}
        </Grid>
      </Grid>
    </Grid>
  )
}

export default E3dcSystemSettingOverview
